import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.reflect.construct";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { __decorate } from "tslib";
import { Component, Vue } from 'nuxt-property-decorator';
import { ClientFactory } from "~/utils/api";
import { getModule } from "vuex-module-decorators";
import FilesModule from "~/store/files";

var Sidebar = /*#__PURE__*/function (_Vue) {
  _inherits(Sidebar, _Vue);

  var _super = _createSuper(Sidebar);

  function Sidebar() {
    var _this;

    _classCallCheck(this, Sidebar);

    _this = _super.apply(this, arguments);
    _this.firstname = '';
    _this.lastname = '';
    _this.email = '';
    _this.permissions = {};
    _this.loading = true;
    _this.showEventFiles = true;
    return _this;
  }

  _createClass(Sidebar, [{
    key: "initModules",
    value: function initModules() {
      this.filesModule = getModule(FilesModule, this.$store);
    }
  }, {
    key: "created",
    value: function () {
      var _created = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.initModules();
                this.api = ClientFactory.createApiClient();
                this.api.deserialize = true;

                if (!this.filesModule.hasEventsWithFiles) {
                  _context.next = 6;
                  break;
                }

                this.loading = false;
                return _context.abrupt("return");

              case 6:
                if (!this.filesModule.hasSubscriptionsWithFiles) {
                  _context.next = 9;
                  break;
                }

                this.loading = false;
                return _context.abrupt("return");

              case 9:
                _context.next = 11;
                return this.getSubscriptionFiles();

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function created() {
        return _created.apply(this, arguments);
      }

      return created;
    }()
  }, {
    key: "getFiles",
    value: function () {
      var _getFiles = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var events;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return this.api.get('/files');

              case 3:
                events = _context2.sent;

                if (!Array.isArray(events)) {
                  events = [events];
                }

                this.filesModule.SET_EVENTS(events);
                _context2.next = 11;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](0);
                this.showEventFiles = false;

              case 11:
                this.loading = false;

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 8]]);
      }));

      function getFiles() {
        return _getFiles.apply(this, arguments);
      }

      return getFiles;
    }()
  }, {
    key: "getSubscriptionFiles",
    value: function () {
      var _getSubscriptionFiles = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var customerId, response, subscriptions;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                this.api.deserialize = false;
                customerId = this.$auth.user.userId;
                _context3.next = 5;
                return this.api.get("/subscription/customer/".concat(customerId));

              case 5:
                response = _context3.sent;
                subscriptions = response.data;

                if (!Array.isArray(subscriptions)) {
                  subscriptions = [subscriptions];
                }

                this.filesModule.SET_SUBSCRIPTION_EVENTS(subscriptions);
                _context3.next = 14;
                break;

              case 11:
                _context3.prev = 11;
                _context3.t0 = _context3["catch"](0);
                this.showEventFiles = false;

              case 14:
                this.loading = false;

              case 15:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 11]]);
      }));

      function getSubscriptionFiles() {
        return _getSubscriptionFiles.apply(this, arguments);
      }

      return getSubscriptionFiles;
    }()
  }, {
    key: "mounted",
    value: function mounted() {
      this.firstname = this.$store.$auth.user.data.firstname;
      this.lastname = this.$store.$auth.user.data.lastname;
      this.email = this.$store.$auth.user.data.email;
      this.permissions = Object.assign(this.permissions, this.$store.$auth.user.permissions);
    }
  }]);

  return Sidebar;
}(Vue);

Sidebar = __decorate([Component({})], Sidebar);
export default Sidebar;